import cardVisa from "assets/images/stripe/card-visa.svg";
import cardMasterCard from "assets/images/stripe/card-mastercard.svg";
import Icon from "components/atom/Icon.tsx";
import {PaymentMethod} from "@stripe/stripe-js";

function PaymentMethodCard(props: {paymentMethod: PaymentMethod, onDelete: () => void}){
    const {paymentMethod, onDelete} = props
    return (
        <div className="rounded-md border border-gray-300 p-2">
            <div className="flex flex-row items-center justify-between gap-4">
                <div className="flex flex-row items-center justify-start gap-4">
                    {paymentMethod.card?.brand === 'visa' && (
                        <img className="block h-auto w-12" src={cardVisa}/>
                    )}
                    {paymentMethod.card?.brand === 'mastercard' && (
                        <img className="block h-auto w-12" src={cardMasterCard}/>
                    )}

                    <div>
                        <p className="text-xs font-medium text-black">
                            **** **** **** {paymentMethod.card?.last4}
                        </p>
                        <p className="pt-1 text-xs font-medium">
                            {paymentMethod.card?.exp_month}/{paymentMethod.card?.exp_year}
                        </p>
                    </div>
                </div>
                <button type="button" className="cursor-pointer appearance-none px-2"
                        onClick={onDelete}
                >
                    <Icon name="x"
                          className=" block h-4 w-4 min-w-4"/>
                </button>
            </div>
        </div>
    )
}

export default PaymentMethodCard
